const axios = require('axios');

async function getAllChats(condition) {
  try {
    const resData = await axios.get('/api/v1/admin/chat/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findChatById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/chat', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateChat(params) {
  try {
    const resData = await axios.put('/api/v1/admin/chat', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getAllChats, findChatById, updateChat };
